import s from './ContainerLK.module.scss'

type PropsType = {
  children: React.ReactNode
  disableMaxWidth?: boolean
}

export const ContainerLK = ({ children, disableMaxWidth = false }: PropsType) => {
  return (
    <div id={'routeScrollId'} className={s.container} >
      <div className={s.subContainer} style={{ maxWidth: disableMaxWidth ? undefined : 1248 }}>{children}</div>
    </div>
  )
}
